// extracted by mini-css-extract-plugin
export default {"ArrowContainer":"ButtonArrowEnterSVG_ArrowContainer__GA12a","Arrow":"ButtonArrowEnterSVG_Arrow__taCnl"};